import { DateMath } from "../../../date/DateMath";
import { AttributeValue } from "../../../dom-tools/AttributeValue";
import { ClassFlag } from "../../../dom-tools/ClassFlag";
import { ElementAttribute } from "../../../dom-tools/ElementAttribute";
import { ElementSelectors } from "../../../dom-tools/ElementSelectors";
import { DateParser } from "../../../date/DateParser";
import { FilterAndSort } from "../FilterAndSort";
import { Filter } from "./Filter";

export class DateFilter extends Filter
{
  static readonly type = new AttributeValue( Filter.setting, "date" );
  static readonly startAttribute = new ElementAttribute( "-start" );
  static readonly endAttribute = new ElementAttribute( "-end" );

  start:Date;
  end:Date;

  constructor( filterSettings:Element )
  {
    super( filterSettings);

    this.start = DateFilter.startAttribute.asDate( filterSettings );
    this.end   = DateFilter.endAttribute.asDate( filterSettings ); 

    let checkbox = ElementSelectors.inputCheckBox.query( filterSettings );

    if ( checkbox )
    {
      this.enabled = checkbox.checked;
    }
    

    //console.log( "created filter:", this.start, this.end, this.enabled );
  }

  _filterElement( e:Element ) :boolean  
  {
    let element = this.getElement( e );

    if ( ! element )
    {
      return false;
    }


    let dateString = element.textContent;
    let dateRange = DateParser.parseInternationalEnglish( dateString );

    let date = dateRange.start;
    //console.log( "filter element:", this.start, this.end, this.enabled, dateString, ">>", date );

    if ( this.start && DateMath.isBefore( dateRange.end, this.start ))
    {
      let difference = dateRange.end.getTime() - this.start.getTime();
     // console.log( "filter element: is before", this.start, this.end, "DIFF:", difference, this.enabled, dateString, ">>", date );
      return false;
    }

    if ( this.end && DateMath.isAfter( dateRange.start, this.end ) )
    {
      let difference = dateRange.start.getTime() - this.end.getTime();
      //console.log( "filter element: is after", this.start, this.end, "DIFF:", difference, this.enabled, dateString, ">>", date );
      return false;
    }

    return true;
  }
}


